// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest, OPS_UPLOAD_TIMEOUT } from "apis/AdminOpsApiCommon";

// 運営ツール: 外見動画の動画差し替え・追加
const AdminOpsAppearanceAssetUploadApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_appearance_asset_upload";

    const ExecAdminOpsAppearanceAssetUploadApi = async (tAppearanceId, assetKind, file, onUploadProgress = null) => {
        const requestParams = { t_appearance_id: tAppearanceId, asset_kind: assetKind };
        const requestBinaryParams = {
            asset_file: { file: file, filename: file.name },
        };
        return ExecOpsRequest(dispatch, { url: url, requestParams: requestParams, requestBinaryParams: requestBinaryParams, timeout: OPS_UPLOAD_TIMEOUT, onUploadProgress: onUploadProgress });
    };

    return ExecAdminOpsAppearanceAssetUploadApi;
};

export default AdminOpsAppearanceAssetUploadApi;
